export default {
  props: ['hybridAuth'],
  methods: {
    register() {
      this.$router.push(this.i18nLink(this.checkout.authType === 'registration' ? 'checkout' : 'login'));
    },
  },
};
